module.exports = __webpack_public_path__ + "static/media/cc-guide.01aee1bd.png";